import { createDispatchHook, createSelectorHook, createStoreHook } from 'react-redux'
import { SuggProdContext } from '../store/context'

export const useStore = createStoreHook(SuggProdContext)
export const useDispatch = createDispatchHook(SuggProdContext)
export const useSelector = createSelectorHook(SuggProdContext)
